<template>
    <div class="px-4 pt-14 pb-4">
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
            <h1 class="text-2xl font-bold text-gray-800 dark:text-white">My Profile</h1>
            <button @click="isEditing = !isEditing"
                class="px-4 py-2 text-sm font-medium bg-primary text-white rounded-lg shadow hover:bg-primary/90 transition">
                {{ isEditing ? 'Cancel' : 'Edit Profile' }}
            </button>
        </div>

        <!-- Profile Card -->
        <div
            class="bg-white dark:bg-neutral-800 rounded-xl shadow-md border border-gray-200 dark:border-neutral-700 p-6 flex flex-col md:flex-row gap-6">

            <!-- Profile Picture -->
            <div class="flex flex-col items-center gap-4">
                <img :src="user.avatar || '/default-avatar.png'" alt="Profile Picture"
                    class="w-32 h-32 rounded-full object-cover border border-gray-200 dark:border-neutral-600" />
                <label v-if="isEditing" class="cursor-pointer text-sm text-primary hover:underline">
                    Change Photo
                    <input type="file" class="hidden" @change="onFileChange" />
                </label>
            </div>

            <!-- Profile Info -->
            <div class="flex-1 space-y-4">
                <!-- Name -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-neutral-300">Full Name</label>
                    <div v-if="!isEditing" class="mt-1 text-gray-800 dark:text-white">{{ user.first_name }} {{
                        user.last_name }}</div>
                    <div v-else>
                        <input type="text" v-model="form.first_name"
                            class="mt-1 w-full px-4 py-2 border rounded-lg border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary" />
                        <input type="text" v-model="form.last_name"
                            class="mt-1 w-full px-4 py-2 border rounded-lg border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary" />
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-neutral-300">Email</label>
                    <div v-if="!isEditing" class="mt-1 text-gray-800 dark:text-white">{{ user.email }}</div>
                    <input v-else type="email" v-model="form.email"
                        class="mt-1 w-full px-4 py-2 border rounded-lg border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary" />
                </div>

                <!-- Bio -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-neutral-300">Phone</label>
                    <div v-if="!isEditing" class="mt-1 text-gray-600 dark:text-neutral-300">{{ user.phone_number }}
                    </div>
                    <textarea v-else v-model="form.phone_number" rows="3"
                        class="mt-1 w-full px-4 py-2 border rounded-lg border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"></textarea>
                </div>

                <!-- Save Button -->
                <div v-if="isEditing" class="pt-4">
                    <button @click="saveProfile"
                        class="inline-flex text-center items-center justify-center px-4 py-4 md:py-2 text-sm font-medium text-white bg-gradient shadow-xl rounded-xl shadow hover:bg-primary/90 transition">
                        {{ $t('Save Changes') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "Account",
    data() {
        return {
            isEditing: false,
            user: {
                avatar: null,
                first_name: "",
                last_name: "",
                email: "",
                phone_number: "",
            },
            form: {},
        };
    },
    created() {
        this.resetForm();
        this.getAccount();
    },
    methods: {
        resetForm() {
            this.form = { ...this.user };
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.form.avatar = URL.createObjectURL(file);
            }
        },
        async saveProfile() {
            try {
                const formData = new FormData();
                formData.append('first_name', this.form.first_name);
                formData.append('last_name', this.form.last_name);
                formData.append('email', this.form.email);
                formData.append('phone_number', this.form.phone_number);

                // If avatar is a File (from input), append it
                const fileInput = this.$el.querySelector('input[type="file"]');
                if (fileInput && fileInput.files[0]) {
                    formData.append('avatar', fileInput.files[0]);
                }

                const response = await axios.post('/api/dashboard/user', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                // Update local user data
                this.user = response.data;
                this.form = { ...this.user };
                this.isEditing = false;

                this.$toast?.success('Profile updated successfully!'); // optional toast
            } catch (error) {
                console.error('Error saving profile:', error);
                this.$toast?.error('Failed to update profile.');
            }
        },
        async getAccount() {
            try {
                this.loading = true;

                const res = await axios.get("/api/dashboard/user", {
                    params: { search: this.search || "" }
                });

                this.user = res.data;
                this.form = { ...this.user };
            } catch (error) {
                if (error.response?.status === 401) {
                    // User is unauthenticated → refresh token or redirect to login
                    console.warn('User unauthenticated. Attempting refresh...');
                    window.location.reload();
                } else {
                    console.error('Error fetching account:', error);
                }
            } finally {
                this.loading = false;
            }
        }
    },
};
</script>
  
<style scoped>
/* Optional: adjust for dark/light mode transitions */
</style>
  